import request from '@/plugin/axios'

export function queryCustList (data) {
  return request({
    url: '/api/admin/queryCustList',
    method: 'get',
    params: data
  })
}
export function queryCustWriteOffRecordByPage (data) {
  return request({
    url: '/api/admin/queryCustWriteOffRecordByPage',
    method: 'get',
    params: data
  })
}
export function custOrderByPage (data) {
  return request({
    url: '/api/admin/custOrderByPage',
    method: 'get',
    params: data
  })
}
